// export {
//   Promise
// } from 'es6-promise-polyfill'
export const XP = window.XPower
export const XUtils = XP.Utils
export const XBrowser = XP.Browser
export const XTemplate = XP.Template

export const WZ = window.IWangZhe
export const WZUtils = WZ.Utils
